// extracted by mini-css-extract-plugin
export default {"app":"App_app__Vpm1C","main":"App_main__rwymO"};